import { Button } from '@mui/material';
import Overlay from 'components/Overlay';
import { CartContext } from 'constants/contexts';
import dayjs from 'dayjs';
import useIsMobile from 'hooks/useIsMobile';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import DateTimePicker from './DateTimePicker';

function ScheduleOrderOverlay({
  open, onClose,
}) {
  const isMobile = useIsMobile();
  const cart = useContext(CartContext);
  const [dateTime, setDateTime] = useState();
  const [hasError, setHasError] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDateTime(dayjs(cart.scheduledTime));
  }, [cart.scheduledTime]);
  useEffect(() => {
    if (open) {
      setHasError(cart.schedulingError);
    }
  }, [open]);

  const handleClose = () => {
    setDateTime(dayjs(cart.scheduledTime));
    setHasError(false);
    onClose();
  };
  const handleUpdateDateTime = (dt) => {
    setDateTime(dt);
    cart.ensureMenuIsAvailable(dt, false)
      .then((failedReason) => {
        setHasError(Boolean(failedReason));
      });
  };
  const handleSubmit = () => {
    if (dateTime == null) {
      return;
    }
    cart.ensureMenuIsAvailable(dateTime)
      .then((failedReason) => {
        if (failedReason) {
          setHasError(true);
          if (location.pathname !== '/order/checkout') {
            cart.setScheduledTime(dateTime.valueOf());
            handleClose();
          }
        } else {
          cart.setScheduledTime(dateTime.valueOf());
          handleClose();
        }
      });
  };

  return (
    <Overlay open={open} onClose={handleClose}>
      <Overlay.Header>
        Date and Time
      </Overlay.Header>
      <Overlay.Content sx={{ p: { xs: 0, md: '16px' } }}>
        <DateTimePicker
          value={dateTime}
          onChange={handleUpdateDateTime}
          hasError={hasError}
        />
      </Overlay.Content>
      <Overlay.Actions>
        <Button
          variant="secondary"
          onClick={handleClose}
          fullWidth={isMobile}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          fullWidth={isMobile}
          onClick={handleSubmit}
          disabled={dateTime == null || cart.menuLoading || (location.pathname === '/order/checkout' && hasError)}
        >
          Select
        </Button>
      </Overlay.Actions>
    </Overlay>
  );
}

export default ScheduleOrderOverlay;
